// Fictional, self-consistent Mastermind/SHDA data. No real people, hashes,
// hosts or credentials: members and agents carry neutral labels on purpose.

const MINUTE = 60_000;

const DEMO_PERMISSIONS = [
    'projects:read', 'repositories:read', 'tiers:read', 'plans:read', 'breakdown:read',
    'tasks:read', 'tasks:review', 'teams:read', 'machines:read', 'events:read',
];

function criteria(...items) {
    return items;
}

function buildTasks(ago) {
    return [
        {
            id: 101, tier_id: 1, repository_id: 1, kind: 'feature', estimate: 'M', priority: 1,
            title: 'Versionar cada entrega antes de abrir la ronda de revisión',
            description: 'Cada entrega guarda commit base y commit entregado para que la revisión compare exactamente lo que se entregó.',
            acceptance_criteria: criteria(
                'La ronda registra base_commit y delivered_commit.',
                'Una entrega sin commit entregado responde 422 con gate version.',
                'El historial muestra todas las rondas de la tarea.',
            ),
            scope: ['src/features/review-rounds/', 'src/routes/agent/deliver.js'],
            workflow_state: 'in_review', modality: 'planned', assigned_to: 'Integrante 02',
            claimed_by: 1, spec_revision: 7, created_at: ago(60 * 52), updated_at: ago(38),
            commits: [
                { hash: 'demo1a2b3c4', message: 'feat: guarda commit base y entregado en la ronda', at: ago(95) },
                { hash: 'demo5d6e7f8', message: 'test: cubre entrega sin commit versionado', at: ago(41) },
            ],
        },
        {
            id: 102, tier_id: 2, repository_id: 1, kind: 'fix', estimate: 'S', priority: 2,
            title: 'Orden «pausar tomas» ignorada cuando el puesto reconecta',
            description: 'Al reconectar, el puesto debe leer el estado deseado vigente antes de tomar trabajo nuevo.',
            acceptance_criteria: criteria(
                'Un puesto pausado que reconecta no toma tareas.',
                'La confirmación indica la revisión de control aplicada.',
            ),
            scope: ['src/features/agent-orders/'],
            workflow_state: 'in_review', modality: 'planned', assigned_to: 'Integrante 03',
            claimed_by: 2, spec_revision: 3, created_at: ago(60 * 30), updated_at: ago(15),
            commits: [{ hash: 'demo9a8b7c6', message: 'fix: lee control vigente al reconectar', at: ago(22) }],
        },
        {
            id: 103, tier_id: 3, repository_id: 3, kind: 'feature', estimate: 'M', priority: 1,
            title: 'Bandeja de atención con filtros por proyecto',
            description: 'La bandeja de atención del panel permite filtrar por proyecto y tipo sin perder la paginación.',
            acceptance_criteria: criteria(
                'El filtro por proyecto viaja en la URL.',
                'La paginación respeta limit y offset del contrato.',
                'Estados vacío y error visibles.',
            ),
            scope: ['src/features/attention/'],
            workflow_state: 'in_review', modality: 'planned', assigned_to: 'Integrante 05',
            claimed_by: 5, spec_revision: 4, created_at: ago(60 * 70), updated_at: ago(64),
            commits: [{ hash: 'democ4d5e6f', message: 'feat: filtros de la bandeja de atención', at: ago(70) }],
        },
        {
            id: 104, tier_id: 5, repository_id: 5, kind: 'feature', estimate: 'L', priority: 1,
            title: 'Inventario de despliegues por servidor',
            description: 'El inventario muestra servicios, versiones desplegadas y estado de salud por servidor.',
            acceptance_criteria: criteria(
                'La lista de servidores se navega con teclado.',
                'Los servicios sin señal se muestran como desconocidos.',
                'Cada despliegue muestra servidor, imagen y versión.',
                'Funciona a 360 px sin scroll horizontal.',
            ),
            scope: ['src/features/deployments/'],
            workflow_state: 'in_review', modality: 'planned', assigned_to: 'Integrante 08',
            claimed_by: 7, spec_revision: 2, created_at: ago(60 * 96), updated_at: ago(130),
            commits: [
                { hash: 'demo0f1e2d3', message: 'feat: inventario de despliegues', at: ago(260) },
                { hash: 'demo4c5b6a7', message: 'feat: detalle de imagen y versión', at: ago(140) },
            ],
        },
        {
            id: 105, tier_id: 1, repository_id: 1, kind: 'feature', estimate: 'M', priority: 3,
            title: 'Resumen de hallazgos por criterio en cada ronda',
            description: 'La ronda resume cuántos criterios cumplen, incumplen o no se comprobaron.',
            acceptance_criteria: criteria('El resumen cuenta cumple, incumple y no_comprobado por separado.'),
            scope: ['src/features/review-rounds/summary.js'],
            workflow_state: 'claimed', modality: 'planned', assigned_to: 'Integrante 02',
            claimed_by: 3, spec_revision: 2, created_at: ago(60 * 20), updated_at: ago(12), commits: [],
        },
        {
            id: 106, tier_id: 2, repository_id: 2, kind: 'feature', estimate: 'S', priority: 1,
            title: 'Recibos de órdenes con resultado ejecutado/fallado/vencido',
            description: 'Cada orden registra un recibo con su resultado para auditar la coordinación.',
            acceptance_criteria: criteria('El recibo guarda el resultado y la hora.', 'Una orden vencida no se ejecuta.'),
            scope: ['src/orders/receipts.js'],
            workflow_state: 'claimed', modality: 'planned', assigned_to: 'Integrante 03',
            claimed_by: 4, spec_revision: 1, created_at: ago(60 * 12), updated_at: ago(4), commits: [],
        },
        {
            id: 107, tier_id: 4, repository_id: 4, kind: 'feature', estimate: 'M', priority: 1,
            title: 'Bridge nativo versionado para compartir, háptica y notificaciones',
            description: 'Interfaz JS pequeña y comprobable con detección de capacidades y errores normalizados.',
            acceptance_criteria: criteria('Sin éxito falso en navegador.', 'Timeout y cancelación probados.'),
            scope: ['src/core/bridge/'],
            workflow_state: 'claimed', modality: 'planned', assigned_to: 'Integrante 06',
            claimed_by: 6, spec_revision: 1, created_at: ago(60 * 6), updated_at: ago(2), commits: [],
        },
        {
            id: 108, tier_id: 5, repository_id: 6, kind: 'feature', estimate: 'M', priority: 2,
            title: 'API de estado de despliegues por servidor',
            description: 'Expone servicios y versiones desplegadas por servidor con paginación estándar.',
            acceptance_criteria: criteria('Lista envuelta en items y pagination.', 'Filtra por servidor y fecha.'),
            scope: ['src/routes/deployments.js'],
            workflow_state: 'claimed', modality: 'planned', assigned_to: 'Integrante 09',
            claimed_by: 8, spec_revision: 3, created_at: ago(60 * 18), updated_at: ago(58), commits: [],
        },
        {
            id: 109, tier_id: 3, repository_id: 3, kind: 'test', estimate: 'S', priority: 4,
            title: 'Pruebas del interceptor de CSRF en escrituras',
            description: 'Cubre que toda escritura envíe X-CSRF-Token desde la cookie csrf_token.',
            acceptance_criteria: criteria('POST, PUT, PATCH y DELETE llevan la cabecera.'),
            scope: ['__tests__/csrf.test.js'],
            workflow_state: 'ready', modality: 'planned', assigned_to: null,
            claimed_by: null, spec_revision: 1, created_at: ago(60 * 9), updated_at: ago(60 * 9), commits: [],
        },
        {
            id: 110, tier_id: 1, repository_id: 1, kind: 'feature', estimate: 'S', priority: 5,
            title: 'Revocar la reserva de una ronda con motivo',
            description: 'QA puede liberar una ronda tomada indicando el motivo.',
            acceptance_criteria: criteria('El motivo es obligatorio.', 'La ronda vuelve a estar disponible.'),
            scope: ['src/features/review-rounds/reservation.js'],
            workflow_state: 'ready', modality: 'planned', assigned_to: null,
            claimed_by: null, spec_revision: 1, created_at: ago(60 * 26), updated_at: ago(60 * 26), commits: [],
        },
        {
            id: 111, tier_id: 6, repository_id: 5, kind: 'fix', estimate: 'S', priority: 2,
            title: 'El menú de servidores tapa el contenido en iPhone con notch',
            description: 'Respetar safe areas en la barra superior del panel de servidores.',
            acceptance_criteria: criteria('El contenido no queda bajo el notch.', 'Sin regresiones en Android.'),
            scope: ['src/global/styles/layout.css'],
            workflow_state: 'ready', modality: 'one_off', assigned_to: null,
            claimed_by: null, spec_revision: 1, created_at: ago(60 * 5), updated_at: ago(60 * 5), commits: [],
        },
        {
            id: 112, tier_id: 4, repository_id: 4, kind: 'feature', estimate: 'M', priority: 2,
            title: 'Pantalla de capacidades del dispositivo',
            description: 'Muestra qué capacidades reales detecta el host y permite probarlas.',
            acceptance_criteria: criteria('Estado claro cuando una capacidad no existe.'),
            scope: ['src/features/device/'],
            workflow_state: 'ready', modality: 'planned', assigned_to: 'Integrante 06',
            claimed_by: null, spec_revision: 1, created_at: ago(60 * 4), updated_at: ago(60 * 4), commits: [],
        },
        {
            id: 113, tier_id: 1, repository_id: 1, kind: 'fix', estimate: null, priority: 9,
            title: 'Hallazgo: la ronda no indica quién la autoaprobó',
            description: 'Durante la revisión de la tarea 101 se vio que self_approved no aparece en el historial.',
            acceptance_criteria: criteria('El historial muestra self_approved.'),
            scope: [], workflow_state: 'proposed', modality: 'planned', assigned_to: null,
            claimed_by: null, origin_task_id: 101, spec_revision: 1, created_at: ago(36), updated_at: ago(36), commits: [],
        },
        {
            id: 114, tier_id: 5, repository_id: 5, kind: 'fix', estimate: null, priority: 9,
            title: 'Hallazgo: contraste insuficiente en servicios sin señal',
            description: 'Los indicadores de servicios sin señal no llegan a 4.5:1 sobre el fondo cálido.',
            acceptance_criteria: criteria('Contraste AA en ambos temas.'),
            scope: [], workflow_state: 'proposed', modality: 'planned', assigned_to: null,
            claimed_by: null, origin_task_id: 104, spec_revision: 1, created_at: ago(125), updated_at: ago(125), commits: [],
        },
        {
            id: 115, tier_id: 7, repository_id: 7, kind: 'feature', estimate: null, priority: 3,
            title: 'Conector de registro de imágenes (exploración)',
            description: 'Evaluar autenticación y consulta de versiones en un registro de imágenes de contenedor.',
            acceptance_criteria: criteria('Documento con riesgos y alternativas.'),
            scope: [], workflow_state: 'proposed', modality: 'planned', assigned_to: null,
            claimed_by: null, spec_revision: 1, created_at: ago(60 * 48), updated_at: ago(60 * 48), commits: [],
        },
        {
            id: 116, tier_id: 2, repository_id: 1, kind: 'feature', estimate: 'M', priority: 1,
            title: 'Interrumpir una ejecución desde el panel',
            description: 'La orden «interrumpir» pide al agente terminar de forma ordenada.',
            acceptance_criteria: criteria('El agente confirma la interrupción.', 'La reserva se libera.'),
            scope: ['src/features/agent-orders/interrupt.js'],
            workflow_state: 'blocked', modality: 'planned', assigned_to: 'Integrante 03',
            claimed_by: null, spec_revision: 2, created_at: ago(60 * 40), updated_at: ago(60 * 3),
            blocked_reason: 'Falta definir qué pasa con el trabajo parcial no versionado.', commits: [],
        },
        {
            id: 117, tier_id: 5, repository_id: 6, kind: 'feature', estimate: 'S', priority: 3,
            title: 'Webhook de confirmación al desplegar',
            description: 'Notifica a SHDA cuando un despliegue termina y reporta su estado de salud.',
            acceptance_criteria: criteria('Reintenta con backoff.', 'Idempotente por request_id.'),
            scope: ['src/integrations/webhook.js'],
            workflow_state: 'blocked', modality: 'planned', assigned_to: 'Integrante 09',
            claimed_by: null, spec_revision: 1, created_at: ago(60 * 30), updated_at: ago(60 * 7),
            blocked_reason: 'Esperando el endpoint de pruebas de SHDA.', commits: [],
        },
        {
            id: 118, tier_id: 3, repository_id: 3, kind: 'feature', estimate: 'M', priority: 2,
            title: 'Vista de rondas de revisión en el detalle de tarea',
            description: 'Lista rondas con hallazgos por criterio y decisión.',
            acceptance_criteria: criteria('Muestra hallazgos por criterio.', 'Muestra la decisión y su motivo.'),
            scope: ['src/features/tasks/layouts/trail.jsx'],
            workflow_state: 'returned', modality: 'planned', assigned_to: 'Integrante 05',
            claimed_by: null, spec_revision: 3, created_at: ago(60 * 50), updated_at: ago(60 * 2),
            last_return: { reason: 'Falta el estado vacío cuando la tarea no tiene rondas.', at: ago(60 * 2) },
            commits: [{ hash: 'demoe1f2a3b', message: 'feat: lista de rondas en detalle', at: ago(60 * 4) }],
        },
        {
            id: 119, tier_id: 1, repository_id: 1, kind: 'feature', estimate: 'S', priority: 2,
            title: 'Rechazar decisiones sobre rondas que no son la vigente',
            description: 'Decidir sobre una ronda antigua responde 409 con gate ronda.',
            acceptance_criteria: criteria('409 con gate ronda y current_round.'),
            scope: ['src/features/review-rounds/decision.js'],
            workflow_state: 'done', modality: 'planned', assigned_to: 'Integrante 02',
            claimed_by: null, spec_revision: 2, created_at: ago(60 * 80), updated_at: ago(60 * 20),
            commits: [{ hash: 'demob2c3d4e', message: 'feat: gate ronda en decisiones', at: ago(60 * 26) }],
        },
        {
            id: 120, tier_id: 6, repository_id: 5, kind: 'feature', estimate: 'M', priority: 1,
            title: 'Inicio de SHDA con accesos por servidor',
            description: 'Pantalla inicial de SHDA con accesos a servidores, servicios y despliegues.',
            acceptance_criteria: criteria('Accesos navegables con teclado.', 'Carga en menos de 2 s en 4G.'),
            scope: ['src/features/home/'],
            workflow_state: 'done', modality: 'planned', assigned_to: 'Integrante 08',
            claimed_by: null, spec_revision: 2, created_at: ago(60 * 140), updated_at: ago(60 * 30),
            commits: [{ hash: 'demof5a6b7c', message: 'feat: inicio con accesos', at: ago(60 * 33) }],
        },
        {
            id: 121, tier_id: 3, repository_id: 3, kind: 'fix', estimate: 'S', priority: 2,
            title: 'El 403 mostraba varios avisos seguidos',
            description: 'Debounce del aviso de permiso a uno cada 2 s.',
            acceptance_criteria: criteria('Un solo aviso por ráfaga de 403.'),
            scope: ['src/core/network/api.js'],
            workflow_state: 'done', modality: 'one_off', assigned_to: 'Integrante 05',
            claimed_by: null, spec_revision: 1, created_at: ago(60 * 60), updated_at: ago(60 * 44),
            commits: [{ hash: 'demo7d8e9f0', message: 'fix: debounce del aviso 403', at: ago(60 * 46) }],
        },
        {
            id: 122, tier_id: 8, repository_id: 8, kind: 'feature', estimate: 'S', priority: 9,
            title: 'Prototipo de tablero en canvas',
            description: 'Exploración descartada: el tablero en canvas no era accesible.',
            acceptance_criteria: criteria('Documentar por qué se descarta.'),
            scope: [], workflow_state: 'discarded', modality: 'planned', assigned_to: null,
            claimed_by: null, spec_revision: 1, created_at: ago(60 * 300), updated_at: ago(60 * 200), commits: [],
        },
    ];
}

function finding(index, criterion, result, note) {
    return { criterion_index: index, criterion, result, note };
}

function buildReviewRounds(ago, tasks) {
    const byId = Object.fromEntries(tasks.map((task) => [task.id, task]));
    const c = (taskId, index) => byId[taskId].acceptance_criteria[index];
    return [
        {
            id: 501, task_id: 101, number: 2, state: 'open', versioned: true,
            base_commit: 'demo000base', delivered_commit: 'demo5d6e7f8', delivered_at: ago(38), delivered_by: 'core-esclavo-01',
            findings: [
                finding(0, c(101, 0), 'cumple', 'Ambos commits quedan en la ronda.'),
                finding(1, c(101, 1), 'cumple', 'Prueba cubre el 422 con gate version.'),
                finding(2, c(101, 2), 'no_comprobado', 'El historial no se pudo abrir en el entorno de revisión.'),
            ],
            decision: null, self_approved: false,
        },
        {
            id: 500, task_id: 101, number: 1, state: 'returned', versioned: true,
            base_commit: 'demo000base', delivered_commit: 'demo1a2b3c4', delivered_at: ago(60 * 3), delivered_by: 'core-esclavo-01',
            findings: [
                finding(0, c(101, 0), 'cumple', 'Correcto.'),
                finding(1, c(101, 1), 'incumple', 'La entrega sin commit respondía 500.'),
                finding(2, c(101, 2), 'no_comprobado', ''),
            ],
            decision: { result: 'returned', reason: 'Responder 422 con gate version en vez de 500.', decided_at: ago(60 * 2), decided_by: 'Integrante 04 · QA' },
            self_approved: false,
        },
        {
            id: 510, task_id: 102, number: 1, state: 'open', versioned: true,
            base_commit: 'demo111base', delivered_commit: 'demo9a8b7c6', delivered_at: ago(15), delivered_by: 'core-esclavo-02',
            findings: [
                finding(0, c(102, 0), 'cumple', 'Reconexión probada con puesto pausado.'),
                finding(1, c(102, 1), 'incumple', 'La confirmación no incluye la revisión aplicada.'),
            ],
            decision: null, self_approved: false,
        },
        {
            id: 520, task_id: 103, number: 1, state: 'open', versioned: true,
            base_commit: 'demo222base', delivered_commit: 'democ4d5e6f', delivered_at: ago(64), delivered_by: 'panel-esclavo-01',
            findings: [
                finding(0, c(103, 0), 'cumple', 'El filtro queda en ?project_id=.'),
                finding(1, c(103, 1), 'cumple', 'Usa limit/offset.'),
                finding(2, c(103, 2), 'cumple', 'Ambos estados visibles.'),
            ],
            decision: null, self_approved: false,
        },
        {
            id: 530, task_id: 104, number: 1, state: 'open', versioned: true,
            base_commit: 'demo333base', delivered_commit: 'demo4c5b6a7', delivered_at: ago(130), delivered_by: 'shda-esclavo-01',
            findings: [
                finding(0, c(104, 0), 'cumple', 'Flechas y Tab funcionan.'),
                finding(1, c(104, 1), 'cumple', ''),
                finding(2, c(104, 2), 'no_comprobado', 'Sin inventario del servidor de pruebas en el entorno de revisión.'),
                finding(3, c(104, 3), 'incumple', 'A 360 px aparece scroll horizontal en la cabecera.'),
            ],
            decision: null, self_approved: false,
        },
        {
            id: 540, task_id: 118, number: 1, state: 'returned', versioned: true,
            base_commit: 'demo444base', delivered_commit: 'demoe1f2a3b', delivered_at: ago(60 * 3), delivered_by: 'panel-esclavo-01',
            findings: [
                finding(0, c(118, 0), 'cumple', ''),
                finding(1, c(118, 1), 'cumple', ''),
            ],
            decision: { result: 'returned', reason: 'Falta el estado vacío cuando la tarea no tiene rondas.', decided_at: ago(60 * 2), decided_by: 'Integrante 07 · QA' },
            self_approved: false,
        },
        {
            id: 550, task_id: 119, number: 1, state: 'approved', versioned: true,
            base_commit: 'demo555base', delivered_commit: 'demob2c3d4e', delivered_at: ago(60 * 24), delivered_by: 'core-esclavo-01',
            findings: [finding(0, c(119, 0), 'cumple', 'Probado con ronda antigua.')],
            decision: { result: 'approved', reason: null, decided_at: ago(60 * 20), decided_by: 'Integrante 04 · QA' },
            self_approved: false,
        },
        {
            id: 560, task_id: 120, number: 1, state: 'approved', versioned: true,
            base_commit: 'demo666base', delivered_commit: 'demof5a6b7c', delivered_at: ago(60 * 32), delivered_by: 'shda-esclavo-01',
            findings: [finding(0, c(120, 0), 'cumple', ''), finding(1, c(120, 1), 'cumple', '1,4 s medido.')],
            decision: { result: 'approved', reason: null, decided_at: ago(60 * 30), decided_by: 'Integrante 10 · QA' },
            self_approved: false,
        },
        {
            id: 570, task_id: 121, number: 1, state: 'approved', versioned: true,
            base_commit: 'demo777base', delivered_commit: 'demo7d8e9f0', delivered_at: ago(60 * 45), delivered_by: 'panel-esclavo-01',
            findings: [finding(0, c(121, 0), 'cumple', '')],
            decision: { result: 'approved', reason: null, decided_at: ago(60 * 44), decided_by: 'Integrante 07 · QA' },
            self_approved: false,
        },
    ];
}

function buildSeats(ago) {
    const seat = (id, label, role, provider, repositoryId, userId, machine, presence, control, work, staleness) => ({
        id, label, role, provider, repository_id: repositoryId, user_id: userId,
        machine: { id: machine.id, label: machine.label, last_seen_at: machine.lastSeen },
        presence: { state: presence },
        control: { effective_state: control, desired_state: control, acknowledged: true },
        work,
        staleness: staleness || { reason: null, since: null, reasons: [] },
    });
    return [
        seat(1, 'core-esclavo-01', 'agent_slave', 'claude_code', 1, 2,
            { id: 11, label: 'equipo-07', lastSeen: ago(0.5) }, 'activa', 'habilitado',
            { state: 'sin_corrida', task: null }),
        seat(2, 'core-esclavo-02', 'agent_slave', 'codex', 1, 3,
            { id: 12, label: 'equipo-09', lastSeen: ago(1) }, 'activa', 'habilitado',
            { state: 'sin_corrida', task: null }),
        seat(3, 'core-esclavo-03', 'agent_slave', 'claude_code', 1, 2,
            { id: 11, label: 'equipo-07', lastSeen: ago(0.3) }, 'activa', 'habilitado',
            { state: 'corriendo', task: { id: 105, title: 'Resumen de hallazgos por criterio en cada ronda', claimed_at: ago(48), claimed_until: ago(-12) } }),
        seat(4, 'core-maestro-01', 'agent_master', 'claude_code', 2, 1,
            { id: 13, label: 'equipo-02', lastSeen: ago(0.2) }, 'activa', 'habilitado',
            { state: 'corriendo', task: { id: 106, title: 'Recibos de órdenes con resultado ejecutado/fallado/vencido', claimed_at: ago(26), claimed_until: ago(-34) } }),
        seat(5, 'panel-esclavo-01', 'agent_slave', 'cursor', 3, 5,
            { id: 14, label: 'equipo-11', lastSeen: ago(19) }, 'sin_conexion', 'habilitado',
            { state: 'sin_corrida', task: null },
            { reason: 'sin_latidos', since: ago(17), reasons: ['sin_latidos', 'sin_conexion'] }),
        seat(6, 'movil-esclavo-01', 'agent_slave', 'claude_code', 4, 6,
            { id: 15, label: 'equipo-14', lastSeen: ago(0.4) }, 'activa', 'habilitado',
            { state: 'corriendo', task: { id: 107, title: 'Bridge nativo versionado para compartir, háptica y notificaciones', claimed_at: ago(90), claimed_until: ago(-30) } }),
        seat(7, 'shda-esclavo-01', 'agent_slave', 'codex', 5, 8,
            { id: 16, label: 'equipo-21', lastSeen: ago(3) }, 'activa', 'pausado',
            { state: 'sin_corrida', task: null }),
        seat(8, 'shda-esclavo-02', 'agent_slave', 'claude_code', 6, 9,
            { id: 17, label: 'equipo-22', lastSeen: ago(1.5) }, 'activa', 'habilitado',
            { state: 'vigencia_vencida', task: { id: 108, title: 'API de estado de despliegues por servidor', claimed_at: ago(118), claimed_until: ago(58) } },
            { reason: 'vigencia_vencida', since: ago(58), reasons: ['vigencia_vencida'] }),
        seat(9, 'shda-maestro-01', 'agent_master', 'other', 6, 10,
            { id: 18, label: 'equipo-23', lastSeen: ago(2) }, 'activa', 'habilitado',
            { state: 'sin_corrida', task: null }),
    ];
}

function buildEvents(ago) {
    const event = (id, minutes, kind, summary, extra) => ({ id, at: ago(minutes), kind, summary, ...extra });
    return [
        event(9020, 2, 'task.progress', 'movil-esclavo-01 reportó avance en el bridge nativo.', { project_id: 3, tier_id: 4, task_id: 107, repository_id: 4, actor: 'movil-esclavo-01' }),
        event(9019, 4, 'task.claimed', 'core-maestro-01 tomó «Recibos de órdenes».', { project_id: 1, tier_id: 2, task_id: 106, repository_id: 2, actor: 'core-maestro-01' }),
        event(9018, 15, 'task.delivered', 'core-esclavo-02 entregó «Orden pausar tomas ignorada…» para revisión.', { project_id: 1, tier_id: 2, task_id: 102, repository_id: 1, actor: 'core-esclavo-02' }),
        event(9017, 17, 'agent.stale', 'panel-esclavo-01 dejó de enviar latidos.', { project_id: 2, repository_id: 3, actor: 'panel-esclavo-01' }),
        event(9016, 36, 'task.proposed', 'Nuevo hallazgo desde la revisión de la tarea 101.', { project_id: 1, tier_id: 1, task_id: 113, repository_id: 1, actor: 'Integrante 04 · QA' }),
        event(9015, 38, 'task.delivered', 'core-esclavo-01 entregó la ronda 2 de «Versionar cada entrega…».', { project_id: 1, tier_id: 1, task_id: 101, repository_id: 1, actor: 'core-esclavo-01' }),
        event(9014, 48, 'task.claimed', 'core-esclavo-03 tomó «Resumen de hallazgos por criterio».', { project_id: 1, tier_id: 1, task_id: 105, repository_id: 1, actor: 'core-esclavo-03' }),
        event(9013, 58, 'task.lease_expired', 'Venció la reserva de «API de estado de despliegues por servidor».', { project_id: 4, tier_id: 5, task_id: 108, repository_id: 6, actor: 'shda-esclavo-02' }),
        event(9012, 64, 'task.delivered', 'panel-esclavo-01 entregó «Bandeja de atención con filtros».', { project_id: 2, tier_id: 3, task_id: 103, repository_id: 3, actor: 'panel-esclavo-01' }),
        event(9011, 120, 'review.decided', 'Ronda devuelta: «Vista de rondas de revisión en el detalle».', { project_id: 2, tier_id: 3, task_id: 118, repository_id: 3, actor: 'Integrante 07 · QA' }),
        event(9010, 120, 'review.decided', 'Ronda 1 devuelta: «Versionar cada entrega…».', { project_id: 1, tier_id: 1, task_id: 101, repository_id: 1, actor: 'Integrante 04 · QA' }),
        event(9009, 130, 'task.delivered', 'shda-esclavo-01 entregó «Inventario de despliegues».', { project_id: 4, tier_id: 5, task_id: 104, repository_id: 5, actor: 'shda-esclavo-01' }),
        event(9008, 180, 'task.blocked', '«Interrumpir una ejecución» quedó bloqueada.', { project_id: 1, tier_id: 2, task_id: 116, repository_id: 1, actor: 'core-esclavo-02' }),
        event(9007, 190, 'agent.order', 'Se pausaron las tomas de shda-esclavo-01.', { project_id: 4, repository_id: 5, actor: 'Integrante 08' }),
        event(9006, 60 * 7, 'task.blocked', '«Webhook de confirmación» espera el endpoint de pruebas.', { project_id: 4, tier_id: 5, task_id: 117, repository_id: 6, actor: 'shda-esclavo-02' }),
        event(9005, 60 * 20, 'review.decided', 'Ronda aprobada: «Rechazar decisiones sobre rondas…».', { project_id: 1, tier_id: 1, task_id: 119, repository_id: 1, actor: 'Integrante 04 · QA' }),
        event(9004, 60 * 22, 'plan.version', 'Plan Core 2026 v5 pasó a revisión.', { project_id: 1, actor: 'core-maestro-01' }),
        event(9003, 60 * 30, 'review.decided', 'Ronda aprobada: «Inicio de SHDA con accesos».', { project_id: 4, tier_id: 6, task_id: 120, repository_id: 5, actor: 'Integrante 10 · QA' }),
    ];
}

function buildAttention(ago) {
    return [
        {
            id: 'att-1', kind: 'revision_incompleta', validity: 'vigente', at: ago(64),
            happened: { what: 'Ronda con criterios sin comprobar', detail: 'El inventario de despliegues tiene un criterio no comprobado y uno incumplido.' },
            reason: 'Necesita tu decisión de QA.',
            resource: { type: 'task', id: 104 }, scope: { project_id: 4 }, actions: [],
        },
        {
            id: 'att-2', kind: 'equipo_ausente', validity: 'vigente', at: ago(17),
            happened: { what: 'Puesto sin latidos', detail: 'panel-esclavo-01 no envía señal desde hace 17 min.' },
            reason: 'La tarea en revisión del panel puede quedar sin seguimiento.',
            resource: { type: 'position', id: 5 }, scope: { project_id: 2 }, actions: [],
        },
        {
            id: 'att-3', kind: 'reserva_perdida', validity: 'vigente', at: ago(58),
            happened: { what: 'Reserva vencida', detail: 'shda-esclavo-02 superó la vigencia de «API de estado de despliegues por servidor».' },
            reason: 'La tarea volverá a la cola si nadie la renueva.',
            resource: { type: 'task', id: 108 }, scope: { project_id: 4 }, actions: [],
        },
    ];
}

export function createDemoDataset(nowMs) {
    const ago = (minutes) => new Date(nowMs - minutes * MINUTE).toISOString();
    const tasks = buildTasks(ago);

    return {
        me: {
            id: 0,
            name: 'Sesión de demostración',
            email: null,
            role: 'admin',
            permissions: DEMO_PERMISSIONS,
        },
        clients: [
            { id: 1, name: 'Trianametría · interno' },
            { id: 2, name: 'SHDA' },
        ],
        projects: [
            { id: 1, client_id: 1, name: 'Mastermind Core', slug: 'mastermind-core', project_state: 'active', bootstrap_phase: 'ready', status: 2,
                description: 'Fuente única del estado del trabajo: planes, tareas, rondas de revisión y coordinación de agentes.', updated_at: ago(4) },
            { id: 2, client_id: 1, name: 'Mastermind Panel', slug: 'mastermind-panel', project_state: 'active', bootstrap_phase: 'ready', status: 2,
                description: 'Panel web para decidir, revisar y seguir el trabajo de los equipos.', updated_at: ago(17) },
            { id: 3, client_id: 1, name: 'Mastermind Mobile', slug: 'mastermind-mobile', project_state: 'active', bootstrap_phase: 'architecture', status: 2,
                description: 'Borrador móvil embebible con bridge nativo para Android e iOS.', updated_at: ago(2) },
            { id: 4, client_id: 2, name: 'SHDA · Despliegues', slug: 'shda-despliegues', project_state: 'active', bootstrap_phase: 'ready', status: 2,
                description: 'Server Hosted Deploy Agent: organización de servidores, servicios y despliegues.', updated_at: ago(58) },
            { id: 5, client_id: 2, name: 'SHDA · Integraciones', slug: 'shda-integraciones', project_state: 'paused', bootstrap_phase: 'discovery', status: 2,
                description: 'Conectores con sistemas externos. Pausado mientras se define el alcance.', updated_at: ago(60 * 48) },
            { id: 6, client_id: 1, name: 'Prototipos 2025', slug: 'prototipos-2025', project_state: 'closed', bootstrap_phase: 'ready', status: 2,
                description: 'Exploraciones cerradas que se conservan como referencia.', updated_at: ago(60 * 200) },
        ],
        repositories: [
            { id: 1, project_id: 1, name: 'mastermind_core', kind: 'backend', default_branch: 'main' },
            { id: 2, project_id: 1, name: 'mastermind_mcp', kind: 'infra', default_branch: 'main' },
            { id: 3, project_id: 2, name: 'mastermind_dashboard', kind: 'admin', default_branch: 'main' },
            { id: 4, project_id: 3, name: 'mastermind_mobile', kind: 'mobile', default_branch: 'main' },
            { id: 5, project_id: 4, name: 'shda_dashboard', kind: 'frontend', default_branch: 'main' },
            { id: 6, project_id: 4, name: 'shda_core', kind: 'backend', default_branch: 'main' },
            { id: 7, project_id: 5, name: 'shda_connectors', kind: 'backend', default_branch: 'main' },
            { id: 8, project_id: 6, name: 'prototype_board', kind: 'frontend', default_branch: 'main' },
        ],
        tiers: [
            { id: 1, project_id: 1, name: 'T42 · Rondas de revisión versionadas', phase: 'construction', tier_state: 'active', breakdown_state: 'agreed' },
            { id: 2, project_id: 1, name: 'T43 · Órdenes a agentes', phase: 'stabilization', tier_state: 'active', breakdown_state: 'agreed' },
            { id: 3, project_id: 2, name: 'T07 · Panel web', phase: 'construction', tier_state: 'active', breakdown_state: 'agreed' },
            { id: 4, project_id: 3, name: 'T01 · Borrador móvil', phase: 'architecture', tier_state: 'active', breakdown_state: 'draft' },
            { id: 5, project_id: 4, name: 'F1 · Inventario de despliegues', phase: 'construction', tier_state: 'active', breakdown_state: 'agreed' },
            { id: 6, project_id: 4, name: 'F0 · Registro de servidores', phase: 'delivery', tier_state: 'active', breakdown_state: 'agreed' },
            { id: 7, project_id: 5, name: 'I1 · Conectores', phase: 'discovery', tier_state: 'active', breakdown_state: 'draft' },
            { id: 8, project_id: 6, name: 'Exploración de tableros', phase: 'operation', tier_state: 'closed', breakdown_state: 'legacy' },
        ],
        plans: [
            { id: 1, project_id: 1, name: 'Plan Core 2026', versions: [
                { number: 5, state: 'in_review', updated_at: ago(60 * 22) },
                { number: 4, state: 'approved', updated_at: ago(60 * 24 * 9) },
            ] },
            { id: 2, project_id: 2, name: 'Plan del panel', versions: [{ number: 2, state: 'approved', updated_at: ago(60 * 24 * 12) }] },
            { id: 3, project_id: 3, name: 'Plan móvil', versions: [{ number: 1, state: 'draft', updated_at: ago(60 * 5) }] },
            { id: 4, project_id: 4, name: 'Plan de despliegues SHDA', versions: [{ number: 3, state: 'approved', updated_at: ago(60 * 24 * 4) }] },
            { id: 5, project_id: 5, name: 'Plan de integraciones', versions: [{ number: 1, state: 'in_review', updated_at: ago(60 * 24 * 2) }] },
        ],
        tasks,
        reviewRounds: buildReviewRounds(ago, tasks),
        teams: [
            { id: 1, name: 'Núcleo', description: 'Core, órdenes a agentes y rondas de revisión.', status: 2 },
            { id: 2, name: 'Superficies', description: 'Panel web y borrador móvil.', status: 2 },
            { id: 3, name: 'SHDA Delivery', description: 'Gestión de servidores, despliegues e integraciones de SHDA.', status: 2 },
        ],
        members: [
            { id: 1, team_id: 1, user_id: 1, display: 'Integrante 01', team_role: 'lead' },
            { id: 2, team_id: 1, user_id: 2, display: 'Integrante 02', team_role: 'dev' },
            { id: 3, team_id: 1, user_id: 3, display: 'Integrante 03', team_role: 'dev' },
            { id: 4, team_id: 1, user_id: 4, display: 'Integrante 04', team_role: 'qa' },
            { id: 5, team_id: 2, user_id: 5, display: 'Integrante 05', team_role: 'lead' },
            { id: 6, team_id: 2, user_id: 6, display: 'Integrante 06', team_role: 'dev' },
            { id: 7, team_id: 2, user_id: 7, display: 'Integrante 07', team_role: 'qa' },
            { id: 8, team_id: 3, user_id: 8, display: 'Integrante 08', team_role: 'lead' },
            { id: 9, team_id: 3, user_id: 9, display: 'Integrante 09', team_role: 'dev' },
            { id: 10, team_id: 3, user_id: 10, display: 'Integrante 10', team_role: 'qa' },
        ],
        projectTeams: [
            { id: 1, project_id: 1, team_id: 1 },
            { id: 2, project_id: 2, team_id: 2 },
            { id: 3, project_id: 3, team_id: 2 },
            { id: 4, project_id: 4, team_id: 3 },
            { id: 5, project_id: 5, team_id: 3 },
            { id: 6, project_id: 2, team_id: 1 },
        ],
        seats: buildSeats(ago),
        events: buildEvents(ago),
        attention: buildAttention(ago),
    };
}
